export const homePath = process.env.PUBLIC_URL;